import dynamic from 'next/dynamic';

const VideosList = dynamic(() => import('./VideosList/VideosList'));
const AddNewVideo = dynamic(() => import('./AddNewVideo/AddNewVideo'));

export { VideosList, AddNewVideo };
